import { IFRAME_NON_STRICT_MODE } from './../../../globals';
import { AppMetadata, OutgoingActions } from './constants';
const allMessageQueues = {};
const isAppLoaded = {};

const sendMessageToIframeWindow = (appName, message) => {
  const frameId = AppMetadata[appName].iframeId;
  const origin = IFRAME_NON_STRICT_MODE ? '*' : AppMetadata[appName].origin;
  window.frames[frameId].contentWindow.postMessage(message, origin);
};

const checkIfAppLoaded = (appName) => {
  return isAppLoaded[appName] || false;
};

export const setAppLoaded = (appName) => {
  isAppLoaded[appName] = true;
};

export const sendMessage = (appName, message) => {
  if (checkIfAppLoaded(appName)) {
    sendMessageToIframeWindow(appName, message);
  } else {
    allMessageQueues[appName] = (allMessageQueues[appName] || []).concat(message);
  }
};

export const flushMessageQueue = (appName) => {
  const queue = allMessageQueues[appName] || [];
  for (const message of queue) {
    sendMessageToIframeWindow(appName, message);
  }
};

export const sendRoutingEvent = (appName, route) => {
  const stringifiedRoute = JSON.stringify({
    type: OutgoingActions.Routing,
    data: route,
  });
  sendMessage(appName, stringifiedRoute);
};

export const sendCredentials = (appName, credentials) => {
  const stringifiedCredentials = JSON.stringify({
    type: OutgoingActions.CREDENTIALS_SHARING,
    data: {
      ...credentials,
      'parent-url': window.location.href,
      'project-name': 'exim',
    },
  });
  sendMessage(appName, stringifiedCredentials);
};
